import { render, staticRenderFns } from "./regist-success.vue?vue&type=template&id=4a7111f3&scoped=true"
import script from "./regist-success.vue?vue&type=script&lang=ts"
export * from "./regist-success.vue?vue&type=script&lang=ts"
import style0 from "./regist-success.vue?vue&type=style&index=0&id=4a7111f3&prod&lang=scss&scoped=true"
import style1 from "./regist-success.vue?vue&type=style&index=1&id=4a7111f3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7111f3",
  null
  
)

export default component.exports